import React, { useContext, useEffect, useState, } from "react";
import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import { Box, Snackbar, Stack, TableBody, TableCell, TableHead, TableRow, } from "@mui/material";
import { Paper } from "@mui/material";
import { TableContainer } from "@mui/material";
import BasicPopover from "../../../Components/Popover";
import LoadingVulpes from "../../../Styles/Loader/loading";
import BeneficiarioNomeIdAlinhadoDireita from "../../../Componentes_modulo/Beneficiario_nome_id_alinhado_direita";
import { StyledTableCellBaseLeft, StyledTableCellCabecalho, StyledTableHeadColor, StyledTableHeadLeft, } from "../../../Styles/tabelCellStyled/customTableCell";
import { del, get, post } from "../../../Services/tokenConfig";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import { IEficienciaAlimBeneficiario } from "../../../Interfaces/beneficiarios/beneficiario";
import { func_print } from "../../../Func_genericas/func_print";
import { useLocation, useNavigate } from "react-router-dom";
import { Alert } from "../../../Components/Alert/Alert";
import { IdentifEficienciaAlimentarEdit } from "./editBeneficiario";
import { isValidEmail } from "../../../Func_genericas/isValidEmail";
import { verify_nif } from "../../../Func_genericas/verify_nif";
import { AuthContext } from "../../../AuthContext/AuthContext";
import EficienciaAlimentarViewTecnico from "../../../Styles/layout/eficienciaAlimentarView";
import { desformatarNumero_return_null } from "../../../Func_genericas/formatar_numero_formato_pt";
import { mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../../Func_genericas/valores_estaticos";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    contents: {
      flexGrow: 1,
      padding: theme.spacing(0),
    },
    toolbars: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(2, 3),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
  })
);



export default function EFIdentBenfExp() {
  const location = useLocation();
  const classes = useStyles();
  const auth = useContext(AuthContext);
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [message, setMessage] = React.useState("");
  const [openSnackSuccess, setOpenSnackSuccess] = React.useState(false);
  const [openSnackError, setOpenSnackError] = React.useState(false);
  const [openDelete, setOpenDelete] = React.useState(false);
  const [idToDelete, setIdToDelete] = useState<number | undefined | null>(null);

  const [editRow, setEditRow] = useState(false);
  const [create, setCreate] = useState(false);

  const [error_email, set_error_email] = useState(false);
  const [error_nif, set_error_nif] = useState(false);
  const [error_nome, set_error_nome] = useState(false);
  const [error_nifap, setError_nifap] = useState<boolean>(false);

  const [beneficiario, setBeneficiario] = useState<IEficienciaAlimBeneficiario | undefined>();
  const [obj_tabela_editar, set_obj_tabela_editar] = useState<IEficienciaAlimBeneficiario>();

  const [flag_editado, set_flag_editado] = React.useState(false);
  const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);

  const handleCloseDialog = () => {
    set_error_email(false)
    set_error_nif(false)
    set_error_nome(false)
    setError_nifap(false)
    set_flag_editado(false)
    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
    handleCancelar()
  };

  const getEficienciaById = async (id: number) => {
    try {
      let res = await get(auth.token.cookie_token, `/get_caderno_eficiencia_id/${id}`);

      if (res.status === 200) {

        setBeneficiario(res.data.result);

        auth.func_set_id_identificacao_from_eficiencia(res.data.result.id_identificacao);


      }
      setIsLoading(false);


    } catch (error) {
      func_print("gerir_eficiencia_alimentar", error, true);
      setIsLoading(false);
    }
  }

  const get_caderno_eficiencia = async (id: number) => {
    try {


      let response = await get(auth.token.cookie_token, `/get_Tabela_ano_eficiencia_ididentificacaoRosto/${id}`);
      if (response.status === 200) {

        setIdToDelete(response.data.result[0].id_registo);
      }
    } catch (error) {
      func_print("get_caderno_eficiencia", error, true);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    (async () => {
      await getEficienciaById(location.state.id_identificacao);
      await get_caderno_eficiencia(location.state.id_identificacao);
    })();
  }, []);

  const handlesave = () => {
    if (editRow === true) {
      handleUpdatetabela();
    } else {
      handleSaveTabela();
    }
  }

  const handleCancelar = () => {
    setEditRow(false);
    setCreate(false);
    set_obj_tabela_editar(undefined);
  }

  const handleSaveTabela = async () => {
    if (obj_tabela_editar === undefined
    ) {
      setMessage("Preencha a tabela antes de gravar!");
      setOpenSnackError(true);
    } else
      try {
        let flag_valido_email = false;
        let flag_valido_nif = false;
        let flag_valido_nome = false;

        if (obj_tabela_editar !== undefined) {
          if (obj_tabela_editar.email !== undefined && isValidEmail(obj_tabela_editar.email) === false) {
            set_error_email(true);
            flag_valido_email = false;
          } else {
            set_error_email(false);
            flag_valido_email = true;
          }
          if (obj_tabela_editar.nif === undefined) {
            set_error_nif(true);
            flag_valido_nif = false;
          } else if (verify_nif(obj_tabela_editar.nif) === false) {
            set_error_nif(true);
            flag_valido_nif = false;
          } else {
            set_error_nif(false);
            flag_valido_nif = true;
          }

          if (obj_tabela_editar.nome === undefined) {
            set_error_nome(true);
            flag_valido_nome = false;
          } else {
            set_error_nome(false);
            flag_valido_nome = true;
          }
        }

        if (flag_valido_email === true && flag_valido_nif && flag_valido_nome) {

          let res = await post(auth.token.cookie_token, "new_caderno_eficiencia", {
            payload: {
              id_identificacao: 0,
              nome: obj_tabela_editar?.nome === undefined ? "" : obj_tabela_editar.nome,
              nif: obj_tabela_editar?.nif === undefined ? "" : obj_tabela_editar.nif,
              nifap: obj_tabela_editar?.nifap === undefined ? "" : obj_tabela_editar.nifap,
              morada: obj_tabela_editar?.morada === undefined ? "" : obj_tabela_editar.morada,
              localizacao: obj_tabela_editar?.localizacao === undefined ? "" : obj_tabela_editar.localizacao,
              codig_postal: obj_tabela_editar?.codig_postal === undefined ? "" : obj_tabela_editar.codig_postal,
              freguesia: obj_tabela_editar?.freguesia === undefined ? "" : obj_tabela_editar.freguesia,
              concelho: obj_tabela_editar?.concelho === undefined ? "" : obj_tabela_editar.concelho,
              telefone: obj_tabela_editar?.telefone === undefined ? null : desformatarNumero_return_null(obj_tabela_editar.telefone),
              email: obj_tabela_editar?.email === undefined ? "" : obj_tabela_editar.email,
              cargo_s: obj_tabela_editar?.cargo_s === undefined ? "" : obj_tabela_editar.cargo_s,
              nome_S: obj_tabela_editar?.nome_S === undefined ? "" : obj_tabela_editar.nome_S,
              morada_S: obj_tabela_editar?.morada_S === undefined ? "" : obj_tabela_editar.morada_S,
              telefone_S: obj_tabela_editar?.telefone_S === undefined ? null : desformatarNumero_return_null(obj_tabela_editar.telefone_S),
              telemvel_S: obj_tabela_editar?.telemvel_S === undefined ? null : desformatarNumero_return_null(obj_tabela_editar.telemvel_S),
              email_S: obj_tabela_editar?.email_S === undefined ? "" : obj_tabela_editar.email_S,
              local_sede_E: obj_tabela_editar?.local_sede_E === undefined ? "" : obj_tabela_editar.local_sede_E,
              codigo_postal_E: obj_tabela_editar?.codigo_postal_E === undefined ? "" : obj_tabela_editar.codigo_postal_E,
              freguesia_E: obj_tabela_editar?.freguesia_E === undefined ? "" : obj_tabela_editar.freguesia_E,
              concelho_E: obj_tabela_editar?.concelho_E === undefined ? "" : obj_tabela_editar.concelho_E,
              bovinos_carne: obj_tabela_editar?.bovinos_carne === undefined ? "" : obj_tabela_editar.bovinos_carne,
              ccdr: obj_tabela_editar?.ccdr === undefined ? "" : obj_tabela_editar.ccdr,
              assistencia: obj_tabela_editar?.assistencia === undefined ? "" : obj_tabela_editar.assistencia,
              identificacao_oc: obj_tabela_editar?.identificacao_oc === undefined ? "" : obj_tabela_editar.identificacao_oc,
              id_agri: location.state.id_agri,
              last_update: new Date().toISOString(),
              create_date: new Date().toISOString(),
              uuid: "",
            }
          });
          if (res.status === 200) {
            setMessage("Gravado com sucesso!");

            setBeneficiario((res.data.result));
            set_flag_editado(false)

            // set_id_agri_eficiencia(el.id_agri)
            auth.func_set_id_agricultor_para_eficiencia_alimentar(res.data.result.id_agri)
            auth.func_setNif_agricultor_from_caderno(res.data.result.nif);
            auth.func_setNome_agricultor_from_caderno(res.data.result.nome)


            set_obj_tabela_editar(undefined);
            setCreate(false);
            setEditRow(false)
            setOpenSnackSuccess(true);
          } else {
            setMessage("Erro ao gravar!");
            setOpenSnackError(true);
          }
          setIsLoading(false);
        }
      } catch (error) {
        func_print("handleSave", error, true);
        setMessage("Erro ao efetuar a sua operação!");
        setOpenSnackError(true);
        setIsLoading(false);
      }
  }

  // editar
  const handleEdit = (obj: IEficienciaAlimBeneficiario) => {
    set_obj_tabela_editar(obj);
    setEditRow(true);
  };

  const handleUpdatetabela = async () => {
    try {
      setIsLoading(true);
      let flag_valido_email = false;
      let flag_valido_nif = false;
      let flag_valido_nome = false;


      if (isValidEmail(obj_tabela_editar?.email) === false) {
        set_error_email(true);
        flag_valido_email = false;
      } else {

        set_error_email(false);
        flag_valido_email = true;
      }
      if (obj_tabela_editar?.nif === undefined) {

        set_error_nif(true);
        flag_valido_nif = false;
      } else if (verify_nif(obj_tabela_editar.nif) === false) {

        set_error_nif(true);
        flag_valido_nif = false;
      } else {

        set_error_nif(false);
        flag_valido_nif = true;
      }

      if (obj_tabela_editar?.nome === undefined) {

        set_error_nome(true);
        flag_valido_nome = false;
      } else {

        set_error_nome(false);
        flag_valido_nome = true;
      }


      if (flag_valido_email === true && flag_valido_nif === true && flag_valido_nome === true) {
        let res = await post(auth.token.cookie_token, `update_caderno_eficiencia`, {
          payload: {
            id_identificacao: obj_tabela_editar?.id_identificacao,
            nome: obj_tabela_editar?.nome === undefined ? "" : obj_tabela_editar.nome,
            nif: obj_tabela_editar?.nif === undefined ? "" : obj_tabela_editar.nif,
            nifap: obj_tabela_editar?.nifap === undefined ? "" : obj_tabela_editar.nifap,
            morada: obj_tabela_editar?.morada === undefined ? "" : obj_tabela_editar.morada,
            localizacao: obj_tabela_editar?.localizacao === undefined ? "" : obj_tabela_editar.localizacao,
            codig_postal: obj_tabela_editar?.codig_postal === undefined ? "" : obj_tabela_editar.codig_postal,
            freguesia: obj_tabela_editar?.freguesia === undefined ? "" : obj_tabela_editar.freguesia,
            concelho: obj_tabela_editar?.concelho === undefined ? "" : obj_tabela_editar.concelho,
            telefone: obj_tabela_editar?.telefone === undefined ? null : obj_tabela_editar.telefone,
            email: obj_tabela_editar?.email === undefined ? "" : obj_tabela_editar.email,
            cargo_s: obj_tabela_editar?.cargo_s === undefined ? "" : obj_tabela_editar.cargo_s,
            nome_S: obj_tabela_editar?.nome_S === undefined ? "" : obj_tabela_editar.nome_S,
            morada_S: obj_tabela_editar?.morada_S === undefined ? "" : obj_tabela_editar.morada_S,
            telefone_S: obj_tabela_editar?.telefone_S === undefined ? null : obj_tabela_editar.telefone_S,
            telemvel_S: obj_tabela_editar?.telemvel_S === undefined ? null : obj_tabela_editar.telemvel_S,
            email_S: obj_tabela_editar?.email_S === undefined ? "" : obj_tabela_editar.email_S,
            local_sede_E: obj_tabela_editar?.local_sede_E === undefined ? "" : obj_tabela_editar.local_sede_E,
            codigo_postal_E: obj_tabela_editar?.codigo_postal_E === undefined ? "" : obj_tabela_editar.codigo_postal_E,
            freguesia_E: obj_tabela_editar?.freguesia_E === undefined ? "" : obj_tabela_editar.freguesia_E,
            concelho_E: obj_tabela_editar?.concelho_E === undefined ? "" : obj_tabela_editar.concelho_E,
            bovinos_carne: obj_tabela_editar?.bovinos_carne === undefined ? "" : obj_tabela_editar.bovinos_carne,
            ccdr: obj_tabela_editar?.ccdr === undefined ? "" : obj_tabela_editar.ccdr,
            assistencia: obj_tabela_editar?.assistencia === undefined ? "" : obj_tabela_editar.assistencia,
            identificacao_oc: obj_tabela_editar?.identificacao_oc === undefined ? "" : obj_tabela_editar.identificacao_oc,
            id_agri: obj_tabela_editar?.id_agri,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: "",
          }
        });

        if (res.status === 200) {
          setMessage("Registado com sucesso!");
          set_flag_editado(false)

          setBeneficiario((res.data.result))
          set_obj_tabela_editar(undefined);
          setEditRow(false);
          setOpenSnackSuccess(true);
        } else {
          setMessage("Erro ao gravar!");
          setOpenSnackError(true);
        }
        setIsLoading(false);
      } else {
        if (flag_valido_email === false) {
          setMessage("Email inválido!");
          setOpenSnackError(true);
        } else if (flag_valido_nif === false) {
          setMessage("NIF inválido!");
          setOpenSnackError(true);
        } else if (flag_valido_nome === false) {
          setMessage("Nome inválido!");
          setOpenSnackError(true);
        }
      }
      setIsLoading(false)
    } catch (error) {
      func_print("handleUpdatetabela", error, true);
      setMessage("Erro ao gravar!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
    // } else {
    //     setMessage("Selecione uma tabela para editar!");
    //     setOpenSnackError(true);
    // }
  };

  // DELETE
  const handleClickOpenDelete = () => {
    setOpenDelete(true);
  };

  const handleDelete = async () => {
    try {
      if (idToDelete !== null) {
        setIsLoading(true);

        let res = await del(auth.token.cookie_token, `/delete_Tabela_ano_eficiencia/${idToDelete}`);

        if (res.status === 200) {
          setMessage("Registo eliminado com sucesso!");
          setOpenDelete(false);
          setIdToDelete(null);
          setBeneficiario(undefined);
          setOpenSnackSuccess(true);

          navigate("/");
        } else {
          setMessage("Erro ao eliminar o registo!");
          setOpenSnackError(true);
        }
        setIsLoading(false);
      }
    } catch (error) {
      func_print("handleDelete", error, true);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };


  return (
    <div className={classes.root}>
      <EficienciaAlimentarViewTecnico title="Identificação do Beneficiário e da Exploração" />
      <main className={classes.contents}>
        <div className={classes.toolbars} />
        <div>
          <Box width="80%" margin="auto">
            <BeneficiarioNomeIdAlinhadoDireita />
          </Box>

          <Snackbar
            open={openSnackSuccess}
            autoHideDuration={2000}
            onClose={() => setOpenSnackSuccess(false)}
          >
            <Alert
              onClose={() => setOpenSnackSuccess(false)}
              severity="success"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          <Snackbar
            open={openSnackError}
            autoHideDuration={2000}
            onClose={() => setOpenSnackError(false)}
          >
            <Alert
              onClose={() => setOpenSnackError(false)}
              severity="error"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          {isLoading ?
            <LoadingVulpes /> :
            <TableContainer
              component={Paper}
              variant="outlined"
              sx={{ height: "auto", width: "auto", m: 2, padding: 2 }}
            >
              <table style={{ width: "100%" }}>
                <TableHead>
                  <TableRow>
                    <StyledTableCellCabecalho
                      colSpan={2}
                      sx={{ fontWeight: 700, fontSize: 18 }}
                    >
                      A.3.4 Melhorar a eficiência alimentar animal
                      para redução das emissões de GEE - Bovinos de
                      Carne
                    </StyledTableCellCabecalho>
                  </TableRow>

                </TableHead>
                <TableBody>
                  {editRow === true || create === true ?
                    <>
                      <TableRow>
                        <TableCell colSpan={8}>
                          <Box sx={{ justifyContent: "end", display: "flex" }}>
                            <ButtonCadernos
                              mostrarBotaoGravar
                              aoClicarGravar={() => handlesave()}
                              mostrarBotaoCancelar
                              aoClicarCancelar={() => {
                                if (flag_editado) {
                                  set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                } else {
                                  handleCancelar()
                                }
                              }} />
                          </Box>
                        </TableCell>
                      </TableRow>
                      <IdentifEficienciaAlimentarEdit
                        book={obj_tabela_editar}
                        set_book={set_obj_tabela_editar}
                        error_nif={error_nif}
                        error_email={error_email}
                        error_nome={error_nome}
                        error_nifap={error_nifap}
                        set_error_nif={set_error_nif}
                        setError_nifap={setError_nifap}
                        set_flag_editado={set_flag_editado}
                      />
                    </>
                    :
                    <>
                      <TableRow>
                        <TableCell colSpan={2}>
                          {beneficiario === undefined ?
                            <Stack direction="row" sx={{ justifyContent: "end" }}>

                              {/* <BarraDeFerramentas
                                                                mostrarBotaoNovo
                                                                textoBotaoNovo="Registar tabela"
                                                                aoClicarNovo={handlecreate}
                                                            /> */}
                            </Stack>
                            :
                            <Stack direction="row" sx={{ justifyContent: "end" }}>
                              <ButtonCadernos
                                mostrarBotaoEditar
                                aoClicarEditar={() => handleEdit(beneficiario)}
                                mostrarBotaoApagar
                                aoClicarApagar={() => handleClickOpenDelete()}
                              />
                            </Stack>
                          }
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <StyledTableHeadColor colSpan={2}>
                          Identificação do operador
                        </StyledTableHeadColor>
                      </TableRow>
                      <TableRow>
                        <StyledTableHeadLeft width="30%">
                          Nome do Beneficiário:
                        </StyledTableHeadLeft>
                        <StyledTableCellBaseLeft>{beneficiario?.nome}</StyledTableCellBaseLeft>
                      </TableRow>
                      <TableRow>
                        <StyledTableHeadLeft>NIF: </StyledTableHeadLeft>
                        <StyledTableCellBaseLeft>{beneficiario?.nif}</StyledTableCellBaseLeft>
                      </TableRow>
                      <TableRow>
                        <StyledTableHeadLeft>NIFAP: </StyledTableHeadLeft>
                        <StyledTableCellBaseLeft>
                          {beneficiario?.nifap}
                        </StyledTableCellBaseLeft>
                      </TableRow>
                      <TableRow>
                        <StyledTableHeadLeft>Morada: </StyledTableHeadLeft>
                        <StyledTableCellBaseLeft>
                          {beneficiario?.morada}
                        </StyledTableCellBaseLeft>
                      </TableRow>
                      <TableRow>
                        <StyledTableHeadLeft>
                          Localização:
                        </StyledTableHeadLeft>
                        <StyledTableCellBaseLeft>
                          {beneficiario?.localizacao}
                        </StyledTableCellBaseLeft>
                      </TableRow>
                      <TableRow>
                        <StyledTableHeadLeft>
                          Código Postal:
                        </StyledTableHeadLeft>
                        <StyledTableCellBaseLeft>
                          {beneficiario?.codig_postal}
                        </StyledTableCellBaseLeft>
                      </TableRow>
                      <TableRow>
                        <StyledTableHeadLeft>Freguesia:</StyledTableHeadLeft>
                        <StyledTableCellBaseLeft>
                          {beneficiario?.freguesia}
                        </StyledTableCellBaseLeft>
                      </TableRow>
                      <TableRow>
                        <StyledTableHeadLeft>Concelho:</StyledTableHeadLeft>
                        <StyledTableCellBaseLeft>
                          {beneficiario?.concelho}
                        </StyledTableCellBaseLeft>
                      </TableRow>
                      <TableRow>
                        <StyledTableHeadLeft>
                          Contacto telefónico
                        </StyledTableHeadLeft>
                        <StyledTableCellBaseLeft>
                          {beneficiario?.telefone}
                        </StyledTableCellBaseLeft>
                      </TableRow>
                      <TableRow>
                        <StyledTableHeadLeft>
                          Correio eletrónico:
                        </StyledTableHeadLeft>
                        <StyledTableCellBaseLeft>
                          {beneficiario?.email}
                        </StyledTableCellBaseLeft>
                      </TableRow>
                      <TableRow>
                        <StyledTableHeadColor colSpan={2}>
                          Sócio gerente ou representante (Quando aplicável)
                          <BasicPopover text={"No caso de sociedades identificar o sócio gerente ou pessoa em quem delegou a responsabilidade técnica da exploração pecuária.\nNo caso de beneficiário em nome individual preencher quando o mesmo nomeou um representante legal ou responsável técnico."} />
                        </StyledTableHeadColor>
                      </TableRow>
                      <TableRow>
                        <StyledTableHeadLeft>
                          Cargo
                          <BasicPopover text={"Sócio gerente\nRepresentante legal\nResponsável técnico"} />
                        </StyledTableHeadLeft>
                        <StyledTableCellBaseLeft>
                          {beneficiario?.cargo_s}
                        </StyledTableCellBaseLeft>
                      </TableRow>
                      <TableRow>
                        <StyledTableHeadLeft>Nome: </StyledTableHeadLeft>
                        <StyledTableCellBaseLeft>
                          {beneficiario?.nome_S}
                        </StyledTableCellBaseLeft>
                      </TableRow>
                      <TableRow>
                        <StyledTableHeadLeft>Morada: </StyledTableHeadLeft>
                        <StyledTableCellBaseLeft>
                          {beneficiario?.morada_S}
                        </StyledTableCellBaseLeft>
                      </TableRow>
                      <TableRow>
                        <StyledTableHeadLeft>
                          Telefone
                        </StyledTableHeadLeft>
                        <StyledTableCellBaseLeft>
                          {beneficiario?.telefone_S}
                        </StyledTableCellBaseLeft>
                      </TableRow>
                      <TableRow>
                        <StyledTableHeadLeft>
                          Telemóvel
                        </StyledTableHeadLeft>
                        <StyledTableCellBaseLeft>
                          {beneficiario?.telemvel_S}
                        </StyledTableCellBaseLeft>
                      </TableRow>
                      <TableRow>
                        <StyledTableHeadLeft>
                          Correio electrónico
                        </StyledTableHeadLeft>
                        <StyledTableCellBaseLeft>
                          {beneficiario?.email_S}
                        </StyledTableCellBaseLeft>
                      </TableRow>
                      <TableRow>
                        <StyledTableHeadColor colSpan={2}>
                          Identificação da exploração
                          <BasicPopover text={"Pretende-se que seja feita a caraterização em termos de localização, área e modo de produção, identificando a possível existência de assistência técnica, tipo de produção animal/vegetal e eventual transformação da produção na própria exploração."} />
                        </StyledTableHeadColor>
                      </TableRow>
                      <TableRow>
                        <StyledTableHeadLeft>
                          Local da sede
                        </StyledTableHeadLeft>
                        <StyledTableCellBaseLeft>
                          {beneficiario?.local_sede_E}
                        </StyledTableCellBaseLeft>
                      </TableRow>
                      <TableRow>
                        <StyledTableHeadLeft>
                          Cód. Postal
                        </StyledTableHeadLeft>
                        <StyledTableCellBaseLeft>
                          {beneficiario?.codigo_postal_E}
                        </StyledTableCellBaseLeft>
                      </TableRow>
                      <TableRow>
                        <StyledTableHeadLeft>Concelho </StyledTableHeadLeft>
                        <StyledTableCellBaseLeft>
                          {beneficiario?.concelho_E}
                        </StyledTableCellBaseLeft>
                      </TableRow>
                      <TableRow>
                        <StyledTableHeadLeft>Freguesia </StyledTableHeadLeft>
                        <StyledTableCellBaseLeft>
                          {beneficiario?.freguesia_E}
                        </StyledTableCellBaseLeft>
                      </TableRow>
                      <TableRow>
                        <StyledTableHeadColor colSpan={2}>
                          Efetivo Pecuário (CN)
                          <BasicPopover text={"Indíce de conversão de cabeças naturais em cabeças normais (CN)\nBovinos com mais de 2 anos - 1,0\nBovinos de 6 meses a 2 anos - 0,6\nBovinos com menos de 6 meses - 0,4"} />
                        </StyledTableHeadColor>
                      </TableRow>
                      <TableRow>
                        <StyledTableHeadLeft>
                          Bovinos de carne (CN)
                          <BasicPopover text={"Total de CN"} />

                        </StyledTableHeadLeft>
                        <StyledTableCellBaseLeft>
                          {beneficiario?.bovinos_carne}
                        </StyledTableCellBaseLeft>
                      </TableRow>
                      <TableRow>
                        <StyledTableHeadLeft>
                          CCDR a que pertence
                          <BasicPopover text={"Identificar a CCDR em cuja área de influência se localiza a sede da exploração."} />
                        </StyledTableHeadLeft>
                        <StyledTableCellBaseLeft>{beneficiario?.ccdr}</StyledTableCellBaseLeft>
                      </TableRow>
                      <TableRow>
                        <StyledTableHeadLeft>
                          Assistência Técnica
                          <BasicPopover text={"Identificação do prestador de assistência técnica"} />
                        </StyledTableHeadLeft>
                        <StyledTableCellBaseLeft>
                          {beneficiario?.assistencia}
                        </StyledTableCellBaseLeft>
                      </TableRow>
                      <TableRow>
                        <StyledTableHeadLeft>
                          Identificação do OC
                          <BasicPopover text={"Identificação do OC - Organismo de Controle e Certificação que efetua as ações de controlo durante todo o ciclo produtivo. \nA lista de OC encontra-se disponível na página da DGADR."} />
                        </StyledTableHeadLeft>
                        <StyledTableCellBaseLeft>
                          {beneficiario?.identificacao_oc}
                        </StyledTableCellBaseLeft>
                      </TableRow>
                    </>
                  }
                </TableBody>
              </table>
            </TableContainer>
          }

          <ConfirmDialog
            open={openDelete}
            onClose={() => setOpenDelete(false)}
            onConfirm={handleDelete}
            message="Deseja eliminar o registo?"
          />
          <ConfirmDialog
            open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
            onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
            onConfirm={() => handleCloseDialog()}
            message={mensagem_tem_a_certeza_de_apagar_alteracoes}
          />


        </div>
        {/* {flag_gerir_eficiencia ?
                    <Dialog
                        open={flag_gerir_eficiencia}
                        onClose={() => setflag_gerir_eficiencia(false)}
                        maxWidth="lg"
                        sx={{ padding: 10 }}
                    >
                        <div style={{ marginLeft: "auto" }}>
                            <BarraDeFerramentas
                                mostrarBotaoCancelar
                                aoClicarCancelar={() => { setflag_gerir_eficiencia(false); }}
                            />
                        </div>
                        <DialogTitle
                            fontFamily="candara" fontSize={22} fontWeight={500}
                        >
                            Criação de Eficiência alimentar
                        </DialogTitle>
                        <DialogContent>
                            <DialogNovaEficienciaAlimentar
                                setValueYear_arg={setValueYear}
                                handleCreateCaderno_arg={handleCreateCadernoEficiencia}
                            />
                        </DialogContent>
                    </Dialog> :
                    <></>} */}
      </main>
    </div>
  );
}